const r=(()=>{try{return self}catch{try{return window}catch{return global}}})();function t(){return{logVerbosityLevel:void 0!==r&&Number(r.CARBON_DEFI_SDK_VERBOSITY)||0}}export{t as getRuntimeConfig};
